import React, { useState } from 'react';

function DownloadOptions({ image }) {
  const [selectedFormat, setSelectedFormat] = useState(image.availableFormats[0]);
  const [selectedSize, setSelectedSize] = useState(image.availableSizes[0]);

  const handleDownload = () => {
    // 获取完整的图片URL
    const imageUrl = process.env.PUBLIC_URL + image.fullUrl;
    
    // 创建一个临时的a标签来下载文件
    const link = document.createElement('a');
    link.href = imageUrl;
    
    // 设置下载文件名
    const extension = selectedFormat.toLowerCase();
    const fileName = `${image.name.toLowerCase().replace(/\s+/g, '-')}-${selectedSize.width}x${selectedSize.height}.${extension}`;
    link.download = fileName;
    
    // 添加到文档中并触发点击
    document.body.appendChild(link);
    link.click();
    
    // 清理DOM
    document.body.removeChild(link);
  };

  return (
    <div className="download-options">
      <div className="option-group">
        <label htmlFor="format">Format:</label>
        <select 
          id="format"
          value={selectedFormat}
          onChange={(e) => setSelectedFormat(e.target.value)}
        >
          {image.availableFormats.map(format => (
            <option key={format} value={format}>{format.toUpperCase()}</option>
          ))}
        </select>
      </div>
      <div className="option-group">
        <label htmlFor="size">Size:</label>
        <select 
          id="size"
          value={JSON.stringify(selectedSize)}
          onChange={(e) => setSelectedSize(JSON.parse(e.target.value))}
        >
          {image.availableSizes.map(size => (
            <option key={`${size.width}x${size.height}`} value={JSON.stringify(size)}>
              {size.name} ({size.width}x{size.height})
            </option>
          ))}
        </select>
      </div>
      <button className="download-button" onClick={handleDownload}>
        Download
      </button>
    </div>
  );
}

export default DownloadOptions; 